<div class="kng-table">
  <div class="kng-table--ribbon" *ngIf="partiallySelected() || allSelected">
    <div class="kng-table--cancel-count">
      <kng-button [state]="state.ribbon.cancelButton" (clicked)="cancelSelection()"></kng-button>
      <div class="kng-table--selected-count-text">
        <span class="kng-table--selected-count" tabindex="0">{{
          countOfSelectedRequests()
          }}</span>
        <span class="kng-table--some-selected-count"
          *ngIf="selectedCount()">{{state.approveUserLimitIndicatorText}}</span>
      </div>
    </div>
    <div class="kng-table--bulk-actions">
      <kng-button *ngFor="let button of state.ribbon.ctaList; let i = index" id="{{ button.id }}"
        class="btn {{ button.className }}" [state]="button.state" (clicked)="emitClickEvent(button.className)">
      </kng-button>
    </div>
  </div>
  <div class="kng-table--desktop-view">
    <div class="table-responsive-md">

      <table class="table w-100" aria-labelledby="table">
        <thead>
          <tr>
            <th *ngIf="!state.loading && state.isCheckbox && state.gridData.length > 0"
              class="kng-table--checkbox-desktop-header">
              <span class="non-breaking-space">&#160;</span>
              <mat-checkbox tabindex="0" [checked]="allSelected" [indeterminate]="partiallySelected()"
                (change)="setAll($event.checked)" [disabled]="state.permissionCheckBoxDisabled === true">
              </mat-checkbox>
            </th>
            <th *ngFor="let header of state.gridHeaders">
              <span tabindex="0">{{ header.label }}</span>
              <span *ngIf="header.isTooltip=== true"  tabindex="0">
                <img matTooltipPosition="below" matTooltip={{state.tooltip?.content}}
                  class="info-image--desktop-view " #tooltipdesktop="matTooltip" 
                  attr.aria-label="{{ state.tooltip?.content }}" alt="info icon" src="assets/business_tooltip_desktop.svg"
                  matTooltipClass="{{state.tooltipClass? state.tooltipClass : 'businessTooltip'}}"
                  matTooltipPositionAtOrigin="true" >
              </span>
            </th>
          </tr>

        </thead>
        <tbody *ngIf="state.gridData && state.gridData.length > 0">
          <tr tabindex="0" *ngFor="let row of state.gridData">
            <td *ngIf="!state.loading && state.isCheckbox" class="kng-table--checkbox-column">
              <span class="non-breaking-space">&#160;</span>
              <mat-checkbox tabindex="0" [(ngModel)]="row.checked" [disabled]="row.disabled === true || state.permissionCheckBoxDisabled === true"
                (ngModelChange)="updateAllSelected()">
              </mat-checkbox>
            </td>
            <td tabindex="0" *ngFor="let col of row.values; let i = index" [ngClass]="{'kng-table--dropdown-column': col.category === tableCategory.select,
            'kng-table--multiline-column': col.category === tableCategory.multiline,
            'kng-table--action-column': col.category === tableCategory.button,
            'kng-table--link-column': col.category === tableCategory.link,
            'kng-table--editData-column': col.category === tableCategory.editData,
            'kng-table--uploadFile-column': col.category === tableCategory.uploadFile}">
          
              <div *ngIf="state.loading" class="gradient-loader"></div>
              <ng-container *ngIf="!state.loading">
                <ng-container *ngIf="col.category === tableCategory.multiline">
                  <div class="kng-table--user-name contact" [ngClass]="col.className ?? '' " [innerHtml]="col.firstLineValue"></div>
                  <div class="kng-table--user-email">
                    {{ col.secondLineValue }}
                  </div>
                  <div class="kng-table--user-email kng-table--show-ellipsis" *ngIf="col.thirdLineValue">
                    {{ col.thirdLineValue }}
                  </div>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.link">
                  <div class="kng-table--user-location">
                    {{ col.value }}
                  </div>
                  <button tabindex="0" class="kng-table--additional-location-count"
                    *ngIf="col.count && !col.redirectionDisabled && !col.hideLink" (click)="redirectToApproveNewUserPage(row.id)">
                    + {{ col.count }}
                  </button>
                  <button tabindex="0" *ngIf="col.count && col.redirectionDisabled && !col.hideLink"
                    class="kng-table--additional-location-count-disabled">
                    + {{ col.count }}
                  </button>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.select">
                  <div class="kng-table--dropdown-container">
                    <mat-select disableOptionCentering yPosition="below" aria-label="Role" disableRipple
                      panelClass="table-select" [(ngModel)]="col.value" name="Role" [disabled]="col.roleDisabled ? col.roleDisabled : false">
                      <mat-option *ngFor="let role of col.options" [value]="role.id">
                        {{ role.name }}
                      </mat-option>
                    </mat-select>
                  </div>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.button">
                  <div class="kng-table--action-buttons">
                    <kng-button tabindex="0" *ngFor="let button of col.ctaList; let i = index" id="{{ button.id }}"
                      class="btn {{ button.className }}" [state]="button.state" [ngClass]="{'restrict-action': button.state.disabled}"
                      (clicked)="emitClickEvent(button.className, row)">
                    </kng-button>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.date">
                  <div class="kng-table--date" attr.aria-label="{{ col.value !== '—' && col.value !== '' && col.value !== null ? (convertStringToDate(col.value)
                | date: 'MM/dd/yyyy') || 'undefined' : 'undefined' }}">
                    {{
                    col.value !== "—" && col.value !== "" && col.value !== null
                    ? (convertStringToDate(col.value)
                    | date: "MM/dd/yyyy") : "—"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.primary">
                  <div class="kng-table--primary" [ngClass]="col.className ?? '' ">
                    {{ col.value }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.editData">
                  <div class="editAdminDetail">
                    <div class="kng-table--user-name companyName">{{ col.firstLineValue }}
                    </div>
                    <span>
                      <button class="editclass" (click)="openEditCompanyDetailsModal(row.id)">
                        <img src={{col.icon?.iconPath}} alt={{col.icon?.altText}}>
                      </button>
                    </span>
                  </div>
                  <div class="kng-table--user-address">
                    {{ col.secondLineValue }}
                  </div>
                  <div class="kng-table--user-email">
                    {{ col.thirdLineValue }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.uploadFile">
                  <div>
                    <button  class="kng-table--user-name fileClass" (click)="getLocationList(row.id)" [disabled]="col.disabled"  [ngClass]="{ 'disabled-link': col.disabled === !isLinkEnabled }">
                      {{ col.firstLineValue }}
                    </button>
                  </div>
                  <div class="kng-table--uploadFile ">
                    <button  class="kng-table--user-name uploadClass" (click)="openUploadFileModal(row, i)"
                     [ngClass]="{'disableUpload': col.icon?.iconPath === 'assets/uploadDisabled.svg'}"> 
                      <img src={{col.icon?.iconPath}} alt={{col.icon?.altText}}>
                      <span>{{ col.thirdLineValue }}</span>
                  </button>
                  </div>
                </ng-container>
              </ng-container>
            </td>

          </tr>

        </tbody>
      </table>

      <div class="kng-table--no-results" *ngIf=" !state.loading && state.gridData.length === 0">
        <img src="{{ state.noResult.image.iconPath }}" alt="{{ state.noResult.image.altText }}" />
        <div class="kng-table--no-results-text">{{ state.noResult.text }}</div>
      </div>
    </div>
  </div>

  <div class="kng-table--mobile-view">
    <div class="kng-table--mobile-container" *ngIf="state.gridData.length > 0">
      <div class="kng-table--mobile-header" *ngIf="state.isCheckbox" tabindex="0">
        <mat-checkbox *ngIf="!state.loading && state.isCheckbox && state.gridData.length > 0" [checked]="allSelected"
          [indeterminate]="partiallySelected()" (change)="setAll($event.checked)" [disabled]="state.permissionCheckBoxDisabled === true">
        </mat-checkbox>

        <span class="kng-table--mobile-select-all" tabindex="0">{{state.selectAll}}</span>
      </div>
      <div class="kng-table--mobile-content">
        <div class="kng-table--mobile-row" *ngFor="let row of state.gridData">
          <div class="kng-table--mobile-sub-container" *ngFor="let col of row.values; let index = index"
          [ngClass]="{ businessaccount: col.isTooltip === true }">
            <div *ngIf="state.loading" class="gradient-loader"></div>
            <ng-container *ngIf="!state.loading">

              <div class="kng-table--mobile-checkbox" *ngIf="state.isCheckbox">
                <mat-checkbox *ngIf="index === 0" [disabled]="row.disabled === true || state.permissionCheckBoxDisabled === true" [(ngModel)]="row.checked"
                  (ngModelChange)="updateAllSelected()">
                </mat-checkbox>
              </div>
              <div class="kng-table--mobile-key" *ngIf="col.category !== tableCategory.button ||col.isTooltip===true" 
               [ngClass]="{ businessaccountTooltip: col.isTooltip === true }">
                <span tabindex="0">{{ col.label }}</span>
                <span *ngIf="col.isTooltip===true">
                <img id="tooltip-{{row.id}}" matTooltipPosition="below" tabindex="0" (click)="showTooltip(row.id)"
                attr.aria-label="{{ state.tooltip?.content }}" class="info-image--mobile-view " alt="info icon"
                src="assets/business_tooltip_mobile.svg">
                </span>
              </div>
              <div class="kng-table--mobile-value"
                [ngClass]="{'kng-table--mobile-dropdown-column': col.category === tableCategory.select,
                'kng-table--editData-column': col.category === tableCategory.editData,
                'kng-table--buttonMobile-column': col.category === tableCategory.button}">
                <ng-container *ngIf="col.category === tableCategory.multiline">
                  <div class="kng-table--user-name contact" tabindex="0" [ngClass]="col.className ?? '' " [innerHtml]="col.firstLineValue"></div>
                  <div class="kng-table--user-email" tabindex="0">
                    {{ col.secondLineValue }}
                  </div>
                  <div class="kng-table--user-email kng-table--show-ellipsis"  tabindex="0" *ngIf="col.thirdLineValue">
                    {{ col.thirdLineValue }}
                  </div>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.link">
                  <div class="kng-table--user-location" tabindex="0">
                    {{ col.value }}
                  </div>
                  <button tabindex="0" class="kng-table--additional-location-count"
                    *ngIf="col.count && !col.redirectionDisabled && !col.hideLink" (click)="redirectToApproveNewUserPage(row.id)">
                    + {{ col.count }}
                  </button>
                  <button tabindex="0" *ngIf="col.count && col.redirectionDisabled && !col.hideLink"
                    class="kng-table--additional-location-count-disabled">
                    + {{ col.count }}
                  </button>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.select">
                  <div class="kng-table--dropdown-container kng-table--mobile-dropdown-container">
                    <select aria-label="Role" [(ngModel)]="col.value" name="Role" [disabled]="col.roleDisabled ? col.roleDisabled : false">
                      <option *ngFor="let role of col.options" [value]="role.id">
                        {{ role.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>

                <ng-container *ngIf="col.category === tableCategory.button">
                  <div class="kng-table--action-buttons">
                    <kng-button *ngFor="let button of col.ctaList; let i = index" id="{{ button.id }}"
                      class="btn {{ button.className }}" [state]="button.state"
                      (clicked)="emitClickEvent(button.className, row)" tabindex="0">
                    </kng-button>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.date">
                  <div class="kng-table--date" attr.aria-label="{{ col.value !== '—' && col.value !== '' && col.value !== null ? (convertStringToDate(col.value)
                | date: 'MM/dd/yyyy') || 'undefined' : 'undefined' }}" tabindex="0">
                    {{
                    col.value !== "—" && col.value !== "" && col.value !== null
                    ? (convertStringToDate(col.value)
                    | date: "MM/dd/yyyy") : "—"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.primary">
                  <div class="kng-table--primary" tabindex="0" [ngClass]="col.className ?? '' ">
                    {{ col.value }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.editData">
                    <div class="kng-table--user-name companyName" tabindex="0">{{ col.firstLineValue }}
                      <button class="editclass" (click)="openEditCompanyDetailsModal(row.id)">
                        <img src={{col.icon?.iconPath}} alt={{col.icon?.altText}}>
                      </button>
                  </div>
                  <div class="kng-table--user-address"  tabindex="0">
                    {{ col.secondLineValue }}
                  </div>
                  <div class="kng-table--user-email"  tabindex="0">
                    {{ col.thirdLineValue }}
                  </div>
                </ng-container>
                <ng-container *ngIf="col.category === tableCategory.uploadFile">
                <div class="kng-table--user-name">
                  <button  class=" kng-table--user-name fileClass" (click)="getLocationList(row.id)" [disabled]="col.disabled"  [ngClass]="{ 'disabled-link': col.disabled === !isLinkEnabled }">
                    {{ col.firstLineValue }}
                  </button>
                </div>
                <div class="kng-table--uploadFile ">
                  <button  class="kng-table--user-name uploadClass" (click)="openUploadFileModal(row, index)"
                   [ngClass]="{'disableUpload': col.icon?.iconPath === 'assets/uploadDisabled.svg'}"> 
                    <img src={{col.icon?.iconPath}} alt={{col.icon?.altText}}>
                    <span>{{ col.thirdLineValue }}</span>
                </button>
                </div>
              </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="kng-table--no-results" *ngIf="!state.loading && state.gridData.length === 0">
      <img src="{{ state.noResult.image.iconPath }}" alt="{{ state.noResult.image.altText }}" />
      <div class="kng-table--no-results-text">{{ state.noResult.text }}</div>
    </div>
  </div>
</div>